import Vue from "vue";
import Router from "vue-router";

import Home from "@/components/HomePage/Home";
import CompanyIntroduce from "@/components/About/CompanyIntroduce";
import CompanyNews from "@/components/About/CompanyNews";
import Cooperate from "@/components/About/Cooperate";
import ContactUs from "@/components/About/ContactUs";
import JoinUs from "@/components/About/JoinUs";
import PWmatIntroduce from "@/components/Product/PWmatIntroduce";
import MLFFIntroduce from "@/components/Product/MLFFIntroduce";
import LS3DFIntroduce from "@/components/Product/LS3DFIntroduce";
import PWMGUIIntroduce from "@/components/Product/PWMGUIIntroduce";
import QStudioIntroduce from "@/components/Product/QStudioIntroduce";
import MSTATIONIntroduce from "@/components/Product/MSTATIONIntroduce";
import DMSTATIONIntroduce from "@/components/Product/D-MSTATIONIntroduce";
import MCLUSTERIntroduce from "@/components/Product/MCLUSTERIntroduce";
import McloudIntroduce from "@/components/Product/McloudIntroduce";
import Integration from "@/components/Product/Integration";
import PotentialDownload from "@/components/Download/PotentialDownload";
import ModuleDownload from "@/components/Download/ModuleDownload";
import UtilityDownload from "@/components/Download/UtilityDownload";
import PWmatTrialDownload from "@/components/Download/PWmatTrialDownload";
import PWmatFreeDownload from "@/components/Download/PWmatFreeDownload";
import GPUDownload from "@/components/Download/GPUDownload";
import DCUDownload from "@/components/Download/DCUDownload";
import CPUDownload from "@/components/Download/CPUDownload";
import pwkitDownload from "@/components/Download/pwkitDownload";
import PWmatUpdateFunc from "@/components/Download/PWmatUpdateFunc";
import PWmatUpdateFuncLS3DF from "@/components/Download/PWmatUpdateFuncLS3DF";
import PWmatUpdateFuncDCU from "@/components/Download/PWmatUpdateFuncDCU";
import PWmatUpdateFuncCPU from "@/components/Download/PWmatUpdateFuncCPU";
import PWmatGetUUID from "@/components/Download/PWmatGetUUID";
import PWmatLicenseFunc from "@/components/Download/PWmatLicenseFunc";
import HighThroughputDownload from "@/components/Download/HighThroughputDownload";
import MCLUSTERDownload from "@/components/Download/MCLUSTERDownload";
import WindowsDownload from "@/components/Download/WindowsDownload";
import LS3DFDownload from "@/components/Download/LS3DFDownload";
import MatPLDownload from "@/components/Download/MatPLDownload";
import FAQPage from "@/components/More/FAQ";
import TestLogPage from "@/components/More/TestLog";
import Forum from "@/components/More/Forum";
import PaperPage from "@/components/More/Paper";
import LogPage from "@/components/More/Log";
import trialPage from "@/components/More/trial";
import CourseVedio from "@/components/Course/Vedio";
import Train from "@/components/Course/Train";
import Camp from "@/components/Course/Camp";
import Seminar from "@/components/Course/Seminar";
import Tutorials from "@/components/Course/Tutorials";
import LongxunRoom from "@/components/Course/LongxunRoom";
import QuickStartTutorial from "@/components/Course/QuickStartTutorial";
import Case from "@/components/Course/Case";
import ReadPaper from "@/components/Course/ReadPaper";
import ModuleClass from "@/components/Course/ModuleClass";
import TestDocument from "@/components/TestDocument/TestDocument";
import CompanyNewsContent from "@/components/About/CompanyNewsContent";
import Industrial from "@/components/solution/Industrial";
import Academic from "@/components/solution/Academic";

import { i18n } from '../main'  // 导入i18n实例
import LangStorage from '../helpers/lang'

Vue.use(Router);
let routes = [
  // 英文首页
  {
    path: '/en',
    name: 'Home-en',
    component: Home,
    meta: {}
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {}
  },
  {
    path: "/company-introduce",
    name: "CompanyIntroduce",
    component: CompanyIntroduce,
    meta: {},
  },
  {
    path: "/cooperate",
    name: "Cooperate",
    component: Cooperate,
    meta: {},
  },
  {
    path: "/company-news/:page",
    name: "CompanyNews",
    component: CompanyNews,
    meta: {},
  },
  {
    path: "/company-news-content/:id",
    name: "CompanyNewsContent",
    component: CompanyNewsContent,
    meta: {},
  },
  {
    path: "/contract-us",
    name: "ContactUs",
    component: ContactUs,
    meta: {},
  },
  {
    path: "/join-us",
    name: "JoinUs",
    component: JoinUs,
    meta: {},
  },
  {
    path: "/pwmat-introduce",
    name: "PWmatIntroduce",
    component: PWmatIntroduce,
    meta: {},
  },
  {
    path: "/mlff",
    name: "MLFFIntroduce",
    component: MLFFIntroduce,
    meta: {},
  },
  {
    path: "/ls3df",
    name: "LS3DFIntroduce",
    component: LS3DFIntroduce,
    meta: {},
  },
  {
    path: "/pwm-gui-introduce",
    name: "PWMGUIIntroduce",
    component: PWMGUIIntroduce,
    meta: {},
  },
  {
    path: "/qstudio-introduce",
    name: "QStudioIntroduce",
    component: QStudioIntroduce,
    meta: {},
  },
  {
    path: "/Integration",
    name: "Integration",
    component: Integration,
    meta: {},
  },
  {
    path: "/mstation-introduce",
    name: "MSTATIONIntroduce",
    component: MSTATIONIntroduce,
    meta: {},
  },
  {
    path: "/double-mstation-introduce",
    name: "DMSTATIONIntroduce",
    component: DMSTATIONIntroduce,
    meta: {},
  },
  {
    path: "/mcluster-introduce",
    name: "MCLUSTERIntroduce",
    component: MCLUSTERIntroduce,
    meta: {},
  },
  {
    path: "/mcloud-introduce",
    name: "McloudIntroduce",
    component: McloudIntroduce,
    meta: {},
  },
  {
    path: "/pwmat-trial-download",
    name: "PWmatTrialDownload",
    component: PWmatTrialDownload,
    meta: {},
  },
  {
    path: "/pwmat-free-download",
    name: "PWmatFreeDownload",
    component: PWmatFreeDownload,
    meta: {},
  },
  {
    path: "/Academic",
    name: "Academic",
    component: Academic,
    meta: {},
  },
  {
    path: "/Industrial",
    name: "Industrial",
    component: Industrial,
    meta: {},
  },
  {
    path: "/gpu-download",
    name: "GPUDownload",
    component: GPUDownload,
    meta: {},
  },
  {
    path: "/dcu-download",
    name: "DCUDownload",
    component: DCUDownload,
    meta: {},
  },
  {
    path: "/cpu-download",
    name: "CPUDownload",
    component: CPUDownload,
    meta: {},
  },
  {
    path: "/potential-download",
    name: "PotentialDownload",
    component: PotentialDownload,
    meta: {},
  },
  {
    path: "/module-download",
    name: "ModuleDownload",
    component: ModuleDownload,
    meta: {},
  },
  {
    path: "/utility-download",
    name: "UtilityDownload",
    component: UtilityDownload,
    meta: {},
  },
  {
    path: "/pwkit-download",
    name: "pwkitDownload",
    component: pwkitDownload,
    meta: {},
  },
  {
    path: "/high-through-put-download",
    name: "HighThroughputDownload",
    component: HighThroughputDownload,
    meta: {},
  },
  {
    path: "/mcluster-download",
    name: "MCLUSTERDownload",
    component: MCLUSTERDownload,
    meta: {},
  },
  {
    path: "/windows-download",
    name: "WindowsDownload",
    component: WindowsDownload,
    meta: {},
  },
  {
    path: "/ls3df-download",
    name: "LS3DFDownload",
    component: LS3DFDownload,
    meta: {},
  },
  {
    path: "/MatPL-download",
    name: "MatPLDownload",
    component: MatPLDownload,
    meta: {},
  },
  {
    path: "/pwmat-update-function",
    name: "PWmatUpdateFunc",
    component: PWmatUpdateFunc,
    meta: {},
  },
  {
    path: "/pwmat-update-function",
    name: "PWmatUpdateFuncLS3DF",
    component: PWmatUpdateFuncLS3DF,
    meta: {},
  },
  {
    path: "/pwmat-update-function",
    name: "PWmatUpdateFuncDCU",
    component: PWmatUpdateFuncDCU,
    meta: {},
  },
  {
    path: "/pwmat-update-function",
    name: "PWmatUpdateFuncCPU",
    component: PWmatUpdateFuncCPU,
    meta: {},
  },
  {
    path: "/get-uuid-function",
    name: "PWmatGetUUID",
    component: PWmatGetUUID,
    meta: {},
  },
  {
    path: "/license-install-function",
    name: "PWmatLicenseFunc",
    component: PWmatLicenseFunc,
    meta: {},
  },
  {
    path: "/faq",
    name: "FAQPage",
    component: FAQPage,
    meta: {},
  },
  {
    path: "/forum",
    name: "Forum",
    component: Forum,
    meta: {},
  },
  {
    path: "/paper",
    name: "PaperPage",
    component: PaperPage,
    meta: {},
  },
  {
    path: "/log",
    name: "LogPage",
    component: LogPage,
    meta: {},
  },
  {
    path: "/trial",
    name: "trialPage",
    component: trialPage,
    meta: {},
  },
  {
    path: "/course-vedio",
    name: "CourseVedio",
    component: CourseVedio,
    meta: {},
  },
  {
    path: "/LongxunRoom",
    name: "LongxunRoom",
    component: LongxunRoom,
    meta: {},
  },
  {
    path: "/QuickStartTutorial",
    name: "QuickStartTutorial",
    component: QuickStartTutorial,
    meta: {},
  },
  {
    path: "/Case",
    name: "Case",
    component: Case,
    meta: {},
  },
  {
    path: "/ReadPaper",
    name: "ReadPaper",
    component: ReadPaper,
    meta: {},
  },
  {
    path: "/ModuleClass",
    name: "ModuleClass",
    component: ModuleClass,
    meta: {},
  },
  {
    path: "/Train",
    name: "Train",
    component: Train,
    meta: {},
  },
  {
    path: "/Camp",
    name: "Camp",
    component: Camp,
    meta: {},
  },
  {
    path: "/Seminar",
    name: "Seminar",
    component: Seminar,
    meta: {},
  },
  {
    path: "/Tutorials",
    name: "Tutorials",
    component: Tutorials,
    meta: {},
  },
  {
    path: "/test-document/:id",
    name: "TestDocument",
    component: TestDocument,
    meta: {},
  },
  {
    path: "/test-log",
    name: "TestLog",
    component: TestLogPage,
    meta: {},
  },
  {
    path: '/:invalidPath(.*)*',
    redirect: () => '/' // 跳转到用户当前语言
  }
];

const router = new Router({
  mode: "history",
  routes: routes,
});

router.beforeEach((to, from, next) => {
  // 自动同步语言（仅处理/en和/）
  if (to.path.startsWith('/en')) {
    i18n.locale = 'en'
    LangStorage.setLang('en')
  }
  next()
})

export default router;
